import React from 'react';
import DSPaper from '../../../design-system/Paper/DSPaper';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import { useTheme } from '@mui/material';

const KlydoFileInputLoading = () => {
  const { palette, spacing } = useTheme();
  return (
    <DSPaper
      sx={{
        display: 'flex',
        height: spacing(15),
        padding: spacing(2, 4),
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderRadius: spacing(3),
        border: `2px dashed ${palette.white[12]}`,
        background: 'transparent',
      }}
    >
      <DSCircularProgress />
    </DSPaper>
  );
};

export default KlydoFileInputLoading;
